import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Text from '../../components/Text';
import { Button, Col, Form, message, Row, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import Box from '../../components/Box';
import SocialSectionItem from './components/SocialSectionItem';
import settingApis, { SocialMediaBody, SocialSourceType } from '../../services/settingApis';
import { useParams } from 'react-router-dom';
import { IResponseSocialMediaItem } from '../../services/apisType';

const SalonSettionReviewSocialMedia = () => {
  const { id = '' } = useParams();
  const [form] = Form.useForm();
  const [lstSocialMedia, setLstSocialMedia] = useState<IResponseSocialMediaItem[]>([]);
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      const _body: SocialMediaBody[] = lstSocialMedia?.map((item) => {
        return {
          socialMediaId: item.id,
          enable: values?.[`active_${item.sourceType}`] || false,
          sourceType: item.sourceType,
          url: values?.[`url_${item.sourceType}`] || '',
        };
      });
      const response = await settingApis.updateSettingSocialMedia(id, _body);
      if (response.status === 200) {
        message.success('Update successfully');
      } else {
        message.error({ content: response.data.message, duration: 2 });
      }
    } catch (error: any) {
        message.error({ content: error.message as string, duration: 1 });
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await settingApis.getSettingSocialMedia(id);
      const data = response?.data?.data || [];
      setLstSocialMedia(data);
      const fieldsValue = data?.reduce((acc: any, item: IResponseSocialMediaItem) => {
        acc[`active_${item.sourceType}`] = item.active || false;
        acc[`url_${item.sourceType}`] = item.urlSocial || '';
        return acc;
      }, {});
      form.setFieldsValue(fieldsValue);    
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Spin spinning={loading}>
      <Form form={form} layout='vertical' onFinish={onFinish}>
        <ContainerStyled>
          <HeaderStyled>
            <Text variant='H7' style={{ fontWeight: 600 }}>
              Social MEDIA
            </Text>
          </HeaderStyled>
          <ContentStyled>
            <Row gutter={32}>
              <Col span={12} style={{ borderRight: '1px solid #DADADA' }}>
                <Box display='flex' flexDirection='column' gap={1}>
                  <SocialSectionItem
                    active_name={`active_${SocialSourceType.GOOGLE}`}
                    url_name={`url_${SocialSourceType.GOOGLE}`}
                    type={SocialSourceType.GOOGLE}
                  />
                  <SocialSectionItem
                    active_name={`active_${SocialSourceType.YELP}`}
                    url_name={`url_${SocialSourceType.YELP}`}
                    type={SocialSourceType.YELP}
                  />
                </Box>
              </Col>
              <Col span={12}>
                <Box display='flex' flexDirection='column' gap={1}>
                  <SocialSectionItem
                    active_name={`active_${SocialSourceType.INSTAGRAM}`}
                    url_name={`url_${SocialSourceType.INSTAGRAM}`}
                    type={SocialSourceType.INSTAGRAM}
                  />
                  <SocialSectionItem
                    active_name={`active_${SocialSourceType.FACEBOOK}`}
                    url_name={`url_${SocialSourceType.FACEBOOK}`}
                    type={SocialSourceType.FACEBOOK}
                  />
                </Box>
              </Col>
            </Row>
            <SubmitButtonStyled type='primary' htmlType='submit'>
              <Box display='flex' alignItems='center' gap={1}>
                <Text variant='CONTENT_1' color='text_1'>
                  Update
                </Text>
              </Box>
            </SubmitButtonStyled>
          </ContentStyled>
        </ContainerStyled>
      </Form>
    </Spin>
  );
};

export default SalonSettionReviewSocialMedia;

const ContainerStyled = styled.div`
  width: 100%;
  margin-top: 15px;
  border-radius: 5px;
  border: 1px solid #dadada;
  background: #f6f7fc;
`;

const HeaderStyled = styled.div`
  border-radius: 5px 5px 0 0;
  padding: 1rem;
  background: #ffffff;
`;

const ContentStyled = styled.div`
  padding: 1rem;
`;
const SubmitButtonStyled = styled(Button)`
  margin-top: 1rem;
  display: inline-flex;
  height: 46px;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 2px;
`;
